<template>
  <el-dialog title="Ansprechpartner" :visible="show" @close="$emit('close')">
    <div class="row">
      <div class="col-sm-12">
        <contact-people-table
          :contactPeople="contactPeople"
        />
        <br>
        <button type="submit" class="btn btn-fill btn-primary"
          @click="$router.push(`/suppliers/${supplier.id}/contact_people/create`)"
        >
          <i class="fa fa-plus"></i> Hinzufügen
        </button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { Dialog } from 'element-ui'
import ContactPeopleTable from './contact-people-table'

export default {
  components: { [Dialog.name]: Dialog, ContactPeopleTable },
  props: ['show', 'contactPeople', 'supplier']
}
</script>

<style>
</style>
